export const REACTIONS_DICT = {
  1: { emoji: '👍', name: 'thumb_up', order: 1 },
  2: { emoji: '👎', name: 'thumb_down', order: 2 },
  3: { emoji: '👏', name: 'clap', order: 3 },
  4: { emoji: '😄', name: 'smile', order: 4 },
  5: { emoji: '🎉', name: 'confetti', order: 7 },
  6: { emoji: '❤️', name: 'heart', order: 8 },
  7: { emoji: '😥', name: 'sad', order: 5 },
  8: { emoji: '😱', name: 'scared', order: 6 },
};
